import { Injectable } from "@angular/core";
import { iUser } from "../../interfaces/security/iUser";

@Injectable()
export class LocalStorageService {
    constructor() { }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('currentUser'));
    }

    getToken() {
        return localStorage.getItem('token');
    }

    setToken(token: string) {
        localStorage.setItem('token', token);
    }

    setCurrentUser(currentUser: iUser) {
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        localStorage.setItem('token', currentUser.token);
    }

    removeCurrentUser() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
    }

    rememberUser(userName: string, pwd: string, rememberMe: boolean) {
        if (!rememberMe) {
            localStorage.removeItem('userName');
            localStorage.removeItem('pwd');
            localStorage.removeItem('rememberMe');
        }
        else {
            localStorage.setItem('userName', userName);
            localStorage.setItem('pwd', pwd);
            localStorage.setItem('rememberMe', rememberMe.toString());
        }
    }

    getRememberedUser() {
        let ru: { userName: string, pwd: string, rememberMe: boolean } = { userName: "", pwd: "", rememberMe: false};

        let val = localStorage.getItem('userName');
        ru.userName = val == null ? "" : val;

        val = localStorage.getItem('pwd');
        ru.pwd = val == null ? "" : val;

        val = localStorage.getItem('rememberMe');
        if (val == null) { val = "";}
        ru.rememberMe = val.toLowerCase() == "true" ? true : false;

        return ru;
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/shared/localStorage.service.ts